<template>
<div :class="demoClass">
    <div class="ac-container">
        <GuestDateSelector />
    </div>
</div>
</template>

<script>
import GuestDateSelector from "@/components/GuestDateSelector.vue";

export default {
    name: "Placepage",
    components: {
        GuestDateSelector
    },
    computed: {
        demoClass: function() {
            return this.$store.state.demoMode ? "is-demo": "";
        },
        isDemoMode: function() {
            return this.$store.state.demoMode;
        }
    }
};
</script>

<style  lang="scss">
    // Add "scoped" attribute to limit CSS to this component only
    @import "../assets/styles/main.scss";

    [data-gr-c-s-loaded="true"] {
        margin: 0;
    }
</style>

<style scoped lang="scss">
    @import "../assets/styles/toolbox.scss";

    .demo-info {
        display: none;

        @include media(min-width, $bp--app-fixed) {
            display: block;
        }
    }

    .is-demo {
        @include media(min-width, $bp--app-fixed) {
            padding: rem(40px);

            .ac-container {
                margin: 0 auto;
                position: relative;
                max-width: rem(1300px);
                width: 100%;
            }

            .ac-container__wrap {
                min-height: rem(470px);
            }
        }

        hr {
            border: none;
            display: block;
            height: rem(2px);
            margin: 1.5rem 0 3rem;
            background-color: #b5b5b5;
        }

        .settings-container {
            display: flex;
            justify-content: space-between;

            > div {
                width: 50%;

                &:first-child {
                    margin-right: rem(25px);
                }

                &:last-child {
                    margin-left: rem(25px);
                }
            }
        }
    }

    .place-info__placeholder {
        display: none;

        @include media(min-width, $bp--app-fixed) {
            display: block;
        }
    }

    .ac-container__wrap {
        display: flex;
    }

</style>
